import { escapeHtml, safeUrl } from '../escape.js';
import { editAttr, itemStr, labeledIntro, list, sectionOpen, str } from './helpers.js';
import type { PatternSectionT } from '../../schema/index.js';

function renderButtons(section: PatternSectionT): string {
  return list(section.fields, 'buttons_data')
    .map((item, index) => {
      const text = itemStr(item, 'text');
      const url = itemStr(item, 'url');
      if (!text || !url) return '';
      let kind = 've-btn--secondary';
      if (index === 0) kind = 've-btn--primary';
      const textPath = `/buttons_data/${index}/text`;
      return `      <a class="ve-btn ${kind}" href="${safeUrl(url)}"${editAttr(section, textPath)}>${escapeHtml(text)}</a>`;
    })
    .filter(Boolean)
    .join('\n');
}

/** cta — heading, supporting content, buttons, and optional split image. */
export function renderCta(section: PatternSectionT): string {
  const heading = str(section.fields, 'heading');
  const content = str(section.fields, 'content');
  const imageUrl = str(section.fields, 'image_url');
  const buttons = renderButtons(section);
  const parts: string[] = [
    sectionOpen(section),
    '  <div class="ve-cta__content">',
    ...labeledIntro(section, 'cta', heading, '', 'h2', '    '),
  ];
  if (content) parts.push(`    <p class="ve-cta__text"${editAttr(section, '/content')}>${escapeHtml(content)}</p>`);
  if (buttons) parts.push(`    <div class="ve-cta__actions"${editAttr(section, '/buttons_data')}>\n${buttons}\n    </div>`);
  parts.push('  </div>');
  if (imageUrl) parts.push(`  <img class="ve-cta__image" src="${safeUrl(imageUrl)}" alt=""${editAttr(section, '/image_url')}>`);
  parts.push('</section>');
  return parts.join('\n');
}
